import { Component } from '@angular/core';

@Component({
    selector: 'gbc-modal-buttons',
    templateUrl: './modal-buttons.component.html',
    styleUrls: ['./modal-buttons.component.scss'],
})
export class ModalButtonsComponent {
  constructor() {}
}
